// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"az_J4c","keyword":"az_K4c","longText":"az_L4c","overflowText":"az_M4c","seeLessButton":"az_N4c","modalContent":"az_O4c"};